import React, { useState, useEffect } from "react";
import { ApiService,getProductTitle } from "../services";
import { MyLocation, FiberManualRecord, MoreHoriz } from "@material-ui/icons";
import styled from "styled-components";
import { GHorCardShimmer } from "../gComponents/gCardShimmer";
import GPagination from "../gComponents/gPagination";
import GPopover from "../gComponents/gPopover";
import { useHistory } from "react-router-dom";
import { ReactComponent as DriverIcon } from "../assets/images/sidebar/drivers.svg";
import GText from "../gComponents/gText";
import { GSearch } from "../gComponents/gSearch";

const DriverListView = styled.div`
  padding: 15px 12px;
  display: flex;
  align-items: center;

  &:hover {
    background: #212226;
  }

  .actionIcon:hover {
    background: #333;
  }
`;

const ContentDiv = styled.div`
  width: calc(100% - 80px);
  padding: 0 10px;
  p {
    margin: 6px 0;
  }
`;

const DriversView = (props) => {
  let history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [driversData, setDriversData] = useState(props.driversData || []);
  const [searchWord, setSearchWord] = useState("");

  useEffect(() => {
    let findInd = driversData.findIndex((d) => d.id == props.updatedDriver?.id);
    if (findInd > -1) {
      driversData[findInd].location_updated =
        props.updatedDriver.location_updated;
      driversData[findInd].lat = props.updatedDriver.lat;
      driversData[findInd].lng = props.updatedDriver.lng;
      setDriversData([...driversData]);
    }
  }, [props.updatedDriver]);
  return (
    <div>
      {isLoading == true ? (
        <>
          <br />
          <GHorCardShimmer theme="dark" height={60} />
        </>
      ) : (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            <GSearch
              placeholder={"Search "+getProductTitle()+".."}
              value={searchWord}
              handleChange={(val) => {
                setSearchWord(val);
              }}
              style={{
                width: "200px",
                border: "0px",
                padding: "5px 8px ",
                background: "#222326",
                margin: "5px",
              }}
              inputStyle={{ color: "#e2e2e2" }}
              iconStyle={{ color: "#999" }}
            />
            <GText
              med
              text={
                driversData.filter((d) => {
                  if (searchWord) {
                    return d.custom_fields?.title
                      .toLowerCase()
                      .includes(searchWord.toLowerCase());
                  } else {
                    return d;
                  }
                }).length +
                " of " +
                driversData.length +
                " "+getProductTitle()
              }
              style={{
                width: "auto",
                margin: "0 20px",
                fontStyle: "italic",
                marginLeft: "auto",
              }}
            />
          </div>
          <div
            style={{
              background: "transparent",
              height: "calc(100vh - 205px)",
              overflow: "overlay",
              paddingBottom: "70px",
            }}
          >
            {driversData.filter((d) => {
              if (searchWord) {
                return d.custom_fields?.title
                  .toLowerCase()
                  .includes(searchWord.toLowerCase());
              } else {
                return d;
              }
            }).length > 0 ? (
              driversData
                .filter((d) => {
                  if (searchWord) {
                    return d.custom_fields?.title
                      .toLowerCase()
                      .includes(searchWord.toLowerCase());
                  } else {
                    return d;
                  }
                })
                .map((o, i) => {
                  return (
                    <DriverListView
                      key={i}
                      onClick={() => {
                        if (o.lat) {
                          props.onClick(o);
                        } else {
                          return;
                        }
                      }}
                      style={{ cursor: o.lat ? "pointer" : "auto" }}
                    >
                      <FiberManualRecord
                        style={{
                          fill:
                            o.driver_status == 1
                              ? o.active_task_count > 0
                                ? "#43829B"
                                : "#76A543"
                              : "#9D9E9D",
                          width: "20px",
                          height: "20px",
                          margin: "0 5px",
                        }}
                        // title={o.status?.title}
                      />

                      <ContentDiv>
                        <GText
                          g4
                          text={o.custom_fields?.title}
                          style={{ color: "#bbb", fontSize: "16px" }}
                        />
                        <GText
                          text={o.address}
                          style={{ color: "#777", fontSize: "14px" }}
                        />
                      </ContentDiv>

                      <div
                        style={{
                          width: "40px",
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "20px",
                          position: "relative",
                          minHeight: "50px",
                        }}
                      >
                        {/* <MoreHoriz
                          style={{
                            fill: "#555",
                            margin: "0",
                            fontSize: "1.5rem",
                            cursor: "pointer",
                            borderRadius: "20px",
                            padding: "2px",
                          }}
                          className={"actionIcon"}
                          onClick={(e) => {
                            e.stopPropagation();
                            driversData.map((o) => {
                              o.showPopover = false;
                            });
                            driversData.filter((d) => {
                              if (searchWord) {
                                return d.title
                                  .toLowerCase()
                                  .includes(searchWord.toLowerCase());
                              } else {
                                return d;
                              }
                            })[i].showPopover = true;
                            setDriversData([...driversData]);
                          }}
                        /> */}
                        {o.showPopover == true && (
                          <GPopover
                            placement={"right"}
                            buttons={[
                              {
                                title: "Show on map",
                                icon: <MyLocation />,
                                link: false,
                                show: o.lat ? true : false,
                                action: () => {
                                  props.onClick(o);
                                },
                              },
                              {
                                title: "View Driver Details",
                                icon: (
                                  <DriverIcon
                                    style={{
                                      fill: "#777",
                                      width: "22px",
                                      height: "22px",
                                    }}
                                  />
                                ),
                                route: "/driver/",
                                state: "driver",
                                show: true,
                                action: () => {
                                  window.open(
                                    process.env.REACT_APP_BASE_URL +
                                      "/driver/" +
                                      o.id +
                                      "/tasks",
                                    "_blank" // <- This is what makes it open in a new window.
                                  );
                                  // history.push({
                                  //   pathname: "/driver/" + o.id + "/tasks",
                                  //   state: "driver",
                                  // });
                                },
                              },
                            ]}
                            show={o.showPopover}
                            onPress={() => {
                              driversData.filter((d) => {
                                if (searchWord) {
                                  return d.custom_fields?.title
                                    .toLowerCase()
                                    .includes(searchWord.toLowerCase());
                                } else {
                                  return d;
                                }
                              })[i].showPopover = false;
                              setDriversData([...driversData]);
                            }}
                            onClick={() => props.onClick(o?.tasks || {})}
                          />
                        )}
                      </div>
                    </DriverListView>
                  );
                })
            ) : (
              <GText
                med
                text={"No Item found"}
                style={{ padding: "30px 0", textAlign: "center" }}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default DriversView;
